export default "__VITE_ASSET__D6KoOKv6__"